export const VIEWSIZE = {
  Medium: 496,
  Large: 1374,
};

export const VIEWPOSITION = {
  Center: 'center',
  Right: 'right',
};
